import * as React from 'react';
import {
    DateField,
    TextField,
    EditButton,
    TextInput,
    FunctionField,
    SelectInput,
} from 'react-admin';
import { DateRangeInput } from '../../components/input';
import { StatusEnum } from '../../common/enum';
import { NotificationTypeEnum } from 'src/common/enum/NotificationTypeEnum';
import { Datagrid, List, IfCanAccess } from 'src/enterprise/ra-rbac';

const listFilters = [
    <TextInput source="search" label="Search" alwaysOn />,
    <SelectInput source="type" choices={NotificationTypeEnum} />,
    <SelectInput source="status" choices={StatusEnum} />,
    <DateRangeInput label='From Date' source={'from_date'}/>,
    <DateRangeInput label="To Date" source={'to_date'}/>
];

export const NotificationList = props => (
    <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="name" />
            <FunctionField label="Type" render={record => NotificationTypeEnum.find(x => x.id === record.type)?.name}/>
            <DateField source="from_date" label="From" showTime/>
            <DateField source="to_date" label="To" showTime/>
            <FunctionField label="Status" render={record => StatusEnum.find(x => x.id === record.status)?.name}/>
            <IfCanAccess action="edit">
                <EditButton />
            </IfCanAccess>
        </Datagrid>
    </List>
);